import { modal } from "../modules/modal2.0";

const aya_modal = new modal();

aya_modal.init({
  parentSelector: '#shifts_resources'
});

